



















import { Component, Prop, Watch, Vue } from "vue-property-decorator";

@Component
export default class UserTranscript extends Vue {
  @Prop() private transcript!: string[];
  @Prop() private fillerData!: number[];
  @Prop() private handleTextSelect!: Function;
  @Prop() private startIndex!: number;
  @Prop() private endIndex!: number;
  @Prop() private disableUserHighlight!: boolean;

  private highlightElTemplate: HTMLElement = document.createElement("span");
  private boldElTemplate: HTMLElement = document.createElement("span");

  private created() {
    this.highlightElTemplate.className = "highlight";
    this.boldElTemplate.className = "bold";
  }

  private handleMouseUp(e: Event) {
    if (this.disableUserHighlight) {
      return;
    }

    let selObj: any = window.getSelection();
    const transcriptTextEl = this.$refs.transcriptText as HTMLElement;
    const childNodes = transcriptTextEl.childNodes;
    let numEmpty = 0;
    let startIndex = -1;
    let endIndex = -1;
    
    if (selObj.toString().length) {
      for (let i = 0; i < childNodes.length; i++) {
        let node = childNodes[i] as HTMLElement;
        // Skip and count whitespace textNodes
        if (!/\S/.test(node.textContent as string)) {
          numEmpty++;
          continue;
        }
      
        if (
          node === selObj.anchorNode ||
          node === selObj.anchorNode.parentNode
        ) {
          startIndex = i - numEmpty;
          if (endIndex >= 0) break;
        }

        if (node === selObj.focusNode || node === selObj.focusNode.parentNode) {
          endIndex = i - numEmpty;
          if (startIndex >= 0) break;
        }
      }
    }

    // Handle both directions of text select
    if (startIndex < endIndex) {
      this.$emit("textSelect", startIndex, endIndex);
    } else {
      this.$emit("textSelect", endIndex, startIndex);
    }
    this.onTranscriptChanged();
  }

  @Watch("startIndex")
  private onStartIndexChanged() {
    this.onTranscriptChanged();
  }

  @Watch("endIndex")
  private onEndIndexChanged() {
    this.onTranscriptChanged();
  }

  @Watch("transcript")
  private onTranscriptChanged() {
    const appendSlicedText = (
      wordArray: string[] ,
      el: HTMLElement,
      start: number,
      end: number
    ) => {
      let beforeSpace = " ";
      if (start === 0) {
        beforeSpace = "";
      }
      const text = wordArray.slice(start, end);
      const textNode = document.createTextNode(
        beforeSpace + text.join(" ") + " "
      );
      el.appendChild(textNode);
    };

    // Parse text data
    const transcriptTextEl = this.$refs.transcriptText as HTMLElement;
    transcriptTextEl.innerHTML = "";
    let textStart = 0;
    const wordArray = this.transcript;
    let i = 0;
    for (i = 0; i < wordArray.length; i++) {
      const word = wordArray[i];
      const wordNode = document.createTextNode(word);
      // const hasPause = this.pauseData.includes(i);
      let hasBold = this.fillerData.includes(i);
      let hasHighlight = i >= this.startIndex && i <= this.endIndex;

      // Add textNode
      if (i > 0) {
        appendSlicedText(wordArray, transcriptTextEl, textStart, i);
        textStart = i;
      }

      let spanEl;
      if (hasHighlight) {
        // Add highlight span
        spanEl = this.highlightElTemplate.cloneNode(true) as HTMLElement;
        if (hasBold) {
          spanEl.classList.add("bold");
        }
      } else if (hasBold) {
        // Add bold span
        spanEl = this.boldElTemplate.cloneNode(true);
      }

      if (spanEl) {
        spanEl.appendChild(wordNode);
        transcriptTextEl.appendChild(spanEl);
        textStart++;
      }
    }

    // Set scroll if highlight offscreen
    let firstHighlight = transcriptTextEl.querySelector(
      ".highlight"
    ) as HTMLElement;
    if (firstHighlight) {
      let offset = firstHighlight.offsetTop;
      transcriptTextEl.scrollTop = offset - transcriptTextEl.clientHeight / 2;
    }

    appendSlicedText(wordArray, transcriptTextEl, textStart, i);
  }
}
